import { render, staticRenderFns } from "./Keyboard.vue?vue&type=template&id=4993fc6d&scoped=true&"
import script from "./Keyboard.vue?vue&type=script&lang=ts&"
export * from "./Keyboard.vue?vue&type=script&lang=ts&"
import style0 from "./Keyboard.vue?vue&type=style&index=0&id=4993fc6d&scoped=true&lang=css&"
import style1 from "./Keyboard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4993fc6d",
  null
  
)

export default component.exports